import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Col, Container, Row } from 'reactstrap';
import moment from 'moment';
import InboxList from 'components/Inbox/InboxList';
import PageTitle from 'components/titles/PageTitle';
import { CLIENT_GROUP } from 'constants/misc';
import { hasUserGroup } from 'utils/permissions';

const Inbox = ({ user: { user_groups: userGroups }, match }) => {
  const isClient = hasUserGroup(userGroups, [CLIENT_GROUP]);
  return (
    <Container>
      <PageTitle>Inbox</PageTitle>
      <Row>
        <Col className="outreach-list">
          <InboxList
            filterStartDate={isClient ? null : moment().subtract(30, 'days')}
            filterEndDate={isClient ? null : moment()}
            messageId={match.params.id}
          />
        </Col>
      </Row>
    </Container>
  );
};

Inbox.propTypes = {
  user: PropTypes.shape({
    user_groups: PropTypes.array,
  }).isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string,
    }),
  }).isRequired,
  location: PropTypes.shape({
    search: PropTypes.shape({}),
  }).isRequired,
};

export default connect(state => ({
  user: state.user,
}))(Inbox);
